import React, { Component } from 'react'
import { addToCard, checkTranslation, imageAddress, translate } from '../../utils/useful';
import Responsive from '../../components/Responsive';
import HttpServices from '../../utils/Http.services';
import { priceStandardView } from '../../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CustomLoader from '../../components/CustomLoader';
import HelpButton from '../../components/HelpButton';
import CommerceInvoiceCalculations from '../../components/CommerceInvoiceCalculations';


export class CartCheckout extends Component {
    state = {
        showCollapse: null,
        active: false,
        isLoading: {},
        // taxes: [{ _id: 1, title: 'GST/HST', percentage: 7, help: 'This is a test description about this tax' }, { _id: 0, title: 'PST/RST/QST', percentage: 5, help: 'This is a test description about this tax' }],
        taxes: [],

    }

    // showNotifications = () => {

    // }

    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    componentDidMount() {
        // console.log('caaaaaaaaaaaaaaaaeeeeerrrrrrrrrrrrrrrrtttttttttt');
        this.setState({ currentIndex: 0 })
        // this.getCart()

        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('')

            })

        }


    }


    changePage = (page, link) => {
        this.props.changePage(page)
        this.props.changeWindowLink(link)
    }


    addToCart = (action, count, item, index) => {
        
        let applet = this.props.variables?.appletId ?? this.props.applet?._id 
        let hub = this.props.variables?.targetHub

        let variants = item.variants
        let additionals = item.additionals
        let isLoading = this.state.isLoading
        isLoading[index] = true
        let product = typeof item.product == 'object' ? item.product?._id : item.product
        this.setState({ isLoading })
        addToCard(applet, hub, product, action, count, variants, additionals, () => {
            console.log('dddddddd')
            delete isLoading[index]
            this.setState({ isLoading })

        })
    }


    goToProduct = (props) => {
        this.props.changePage(['product', props.product._id])
    }


    render() {

        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`

        let cart = {}
      
        if (this.props.carts?.applets) {
            let appletId = this.props.variables?.appletId?? this.props.applet?._id 
            cart = this.props.carts?.applets[appletId]
        }

        // console.log("this.props.carts",this.props.carts)

        return (
            <div className='w-100  h-100 d-flex flex-column scroll-no-scrollbar pb-5' style={{ backgroundColor: "#f6f6f6" }}>
                {/* <div className='mt-3 mx-3 p-2 bg-white br-10 ' >
                    <div className='flexc w-100 sc-gray' style={{ overflowX: 'auto' }}>

                        <button className='mld-5 mrd-5 flexc commerce-progress-a' >
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/cart-commerce.svg' />
                            <p className='font-size-14 ' style={{ whiteSpace: "nowrap" }}>{translate('Your cart')}</p>
                        </button>

                        <img width={15} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/truck-commerce.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Time and Delivery')}</p>
                        </button>

                        <img width={15} style={{ opacity: ".5" }} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/pay-commerce.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Payment')}</p>
                        </button>

                    </div>
                </div> */}



                <div className='d-flex flex-wrap mt-3'>
                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '8', lg: "8", xl: "9" }}>
                        <div>
                            <div className='mx-3 mb-2'>

                                {/* <div className='flexc w-100 sc-gray mb-2' style={{ overflowX: 'auto' }}>

                                    <button className=' mrd-2 flexc commerce-progress-a' >
                                        <img className='mrd-2' width={22} src='/assets/icons/commerce/cart-commerce.svg' />
                                        <p className='font-size-14 ' style={{ whiteSpace: "nowrap" }}>{translate('Cart')}</p>
                                    </button>

                                    <img width={15} src='/assets/icons/arrow-right-black.svg' />

                                    <button className='mld-2 mrd-2 flexc commerce-progress'>
                                        <img className='mrd-2' width={22} src='/assets/icons/commerce/truck-commerce.svg' />
                                        <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Delivery')}</p>
                                    </button>

                                    <img width={15} style={{ opacity: ".5" }} src='/assets/icons/arrow-right-black.svg' />

                                    <button className='mld-2 mrd-2 flexc commerce-progress'>
                                        <img className='mrd-2' width={22} src='/assets/icons/commerce/pay-commerce.svg' />
                                        <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Payment')}</p>
                                    </button>

                                </div> */}


                                <div className='px-4 br-10 py-3 flexcb' style={{ backgroundColor: "#fff" }}>
                                    <div>
                                        <p className='text-bold  text-semibig'>Shopping cart</p>
                                        {/* <p className='text-bold  text-smallest'>2. Delivery</p>
                                        <p className='text-bold  text-smallest'>3. Payment</p> */}

                                    </div>
                                    {/* <div className='flexc mt-2'>
                                        <div className='flexcc'>
                                            <img className='br-30' src={imageAddress(this.props.variables?.applet?.hub?.image, 'profile', 'small')} height={40} width={40} />
                                        </div>
                                        <div className='mld-4'>
                                            <p className='text-bold  text-small'>{this.props.variables?.applet?.name}</p>
                                            <p className='text-semibold  text-smaller'>{this.props.variables?.applet?.hub?.name} @{this.props.variables?.applet?.hub?.username}</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className='mx-3 mb-3 p-3 br-10 ' style={{ backgroundColor: "#fff" }}>

                                <div>
                                    {(!cart?.items || cart?.items.length == 0) && (
                                        <div className='flexcc flex-column py-5 px-4'>
                                            <img src="/assets/icons/useful/empty.png" alt='' width={70} />
                                            <p className='text-semibold text-semibig mt-2'>{translate("Cart is empty")}</p>
                                            <p className='text-small mt-1'>{translate("Please add some items first then come back to this page")}</p>

                                        </div>
                                    )}

                                    {Array.isArray(cart?.items) && cart.items?.map((props, index) => {

                                        return (
                                            <div className={'d-flex  pb-3 pt-1th-3 bb-gray ' + (this.props.width < 576 ? ' flex-wrap' : '')}>

                                                <Responsive className={''} width={this.props.width} media={{ xs: "100%", sm: '150px' }}>

                                                    <div >
                                                        <img width={'100%'} className='br-5' style={{ aspectRatio: '1 / 1', objectFit: 'cover', maxWidth: 200 }} src={imageAddress(props.product?.media)} onClick={() => this.changePage('product', ['product', props.product?._id])} />
                                                        {/* <div className=" flexcb w-100 br-30 p-1 mt-3" style={{ backgroundColor: '#eee' }}>
                                                    <button className='flexcc add-btn p-1 br-30' onClick={() => this.addToCart('subtract', 1, props, index)} style={{ cursor: 'pointer', }}>
                                                        <img className='' style={{ opacity: '.7' }} src='/assets/icons/minimize.svg' width={20} />
                                                    </button>
                                                    <p className='font-size-12 text-center br-5 main-c2' style={{ width: '80px' }}>{props.count}
                                                    </p>
                                                    <button className='flexcc add-btn p-1 br-30' onClick={() => this.addToCart("add", 1, props, index)} style={{ cursor: 'pointer' }}>
                                                        <img className='' style={{ opacity: '.7' }} src='/assets/icons/plus.svg' width={20} />
                                                    </button>
                                                </div> */}
                                                    </div>

                                                </Responsive>

                                                <Responsive className={''} width={this.props.width} media={{ xs: "100%" }}>

                                                    <div className={' w-100 ' + (this.props.width < 576 ? '' : 'mld-4')}>

                                                        {props.product?.type != 'membership' && (
                                                            <button className='mb-1' onClick={() => this.goToProduct(props)}>
                                                                <p className='font-size-16 weight-600 '>{checkTranslation(props.product?.name)}</p>
                                                            </button>
                                                        )}

                                                        {props.product?.type == 'membership' && (
                                                            <div className='mb-1' >
                                                                <p className='font-size-16 weight-600 '>{translate("Subscribe")}: {checkTranslation(props.product?.name)} - {props?.variants?.repeat} {translate(props?.variants?.duration)}</p>
                                                            </div>
                                                        )}


                                                        {props.product?.type == 'membership' && (
                                                            <p className='text-small'>USD {props?.variants?.price} ✕ {props.count} = USD {props?.variants?.price * props.count} / month</p>
                                                        )}

                                                        {props.product?.type == 'membership' && props?.variants?.duration == 'year' && (
                                                            <p className='text-small'>Billed annualy</p>
                                                        )}


                                                        {props.product?.type != 'membership' && props?.variants && (
                                                            <div className='w-100'>
                                                                {Object.entries(props?.variants)?.map(([key, value]) => {
                                                                    return (
                                                                        <p className='font-size-13 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-13'>{key}:</span> {value}</p>
                                                                    )
                                                                })}
                                                            </div>
                                                        )}


                                                        {typeof props?.additionals == 'object' && (
                                                            <div className='w-100'>
                                                                {Object.entries(props?.additionals)?.map(([key, value]) => {
                                                                    return (
                                                                        <div>
                                                                            <span className='font-size-13 weight-400 main-c7 ' style={{ textTransform: 'capitalize' }}>{key}:
                                                                                {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                                                                    return (
                                                                                        <span>
                                                                                            {optionKey == 'text' ? (
                                                                                                <span className='font-size-13 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                                                            ) : (
                                                                                                <>
                                                                                                    <span className='font-size-13 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                                                        {(optionValue?.priceDifference != null && optionValue?.priceDifference > 0) && (
                                                                                                            <span className='font-size-13 weight-400 main-c7 mld-1'>
                                                                                                                ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </span>

                                                                                                </>
                                                                                            )}
                                                                                            {(oindex < (Object.entries(value).length - 1)) && (
                                                                                                <span className='mld-1'>,</span>
                                                                                            )}
                                                                                        </span>
                                                                                    )
                                                                                })}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        )}

                                                        <div className='flexcb w-100 mt-2 prd-3' >
                                                            <div className='w-100'>
                                                                <div className='flexc'>
                                                                    <p className='font-size-16 weight-700  '> ${priceStandardView(props.amounts?.final)}</p>

                                                                    {(props.amounts?.base != props.amounts?.final) && (
                                                                        <p className='font-size-14 main-c4 text-lined mld-2'>${priceStandardView(props.amounts?.base)}</p>
                                                                    )}
                                                                    {(props.product?.price?.onSale && !props.amounts?.additionals) && (
                                                                        <p className='font-size-12 mld-2  px-2 br-30' style={{ color: '#fff', backgroundColor: "rgb(204, 12, 57)" }}>{props.product?.price?.discount?.value}{props.product?.price?.discount?.unit ?? '%'}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className='flexcb br-30 p-1 ' style={{ border: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                                                                <button onClick={() => this.addToCart('subtract', 1, props, index)} className='br-30'>
                                                                    <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/minimize.svg' />
                                                                </button>
                                                                <div className='px-3 position-relative'>
                                                                    {this.state.isLoading[index] && (
                                                                        <div className='w-100 flexcc' style={{ position: 'absolute', top: 6, left: 0 }}>
                                                                            <CustomLoader isLoading={true} type={'ThreeDots'} color={'#444'} height={10} />
                                                                        </div>
                                                                    )}

                                                                    <p className='main-c4 weight-700' style={{ color: this.state.isLoading[index] ? 'transparent' : null }}>{props.count}</p>

                                                                </div>
                                                                <button onClick={() => this.addToCart("add", 1, props, index)} className='br-30'>
                                                                    <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/plus.svg' />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {Array.isArray(props?.product?.benefits) && (
                                                            <div className='w-100 mt-2'>
                                                                {props.product.benefits?.map((prop) => {
                                                                    return (

                                                                        <div className='flexc pb-2' style={{ alignItems: 'start' }}>
                                                                            <div className='mrd-2 flexcc'>
                                                                                {prop.description ? (
                                                                                    <HelpButton data={prop.description} />
                                                                                ) : (
                                                                                    <div className='flexcc pld-1'>
                                                                                        <img src='/assets/icons/useful/checkmark.png' width={18} alt='' />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <p className="d-flex" style={{ fontSize: '13px', textAlign: 'start', }}>{checkTranslation(prop.title)}</p>
                                                                        </div>
                                                                        // <p className='font-size-13 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-13'>{key}:</span> {value}</p>
                                                                    )
                                                                })}

                                                            </div>
                                                        )}

                                                        {/* <p className='font-size-12 main-c7 title-color'>This a description of the product in the cart witch will show some spec.</p> */}
                                                        {/* <div className='d-flex flex-wrap'>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='mt-3'>
                                                            <p className='font-size-16 title-color'>{checkTranslation(props.product?.price?.final)}</p>
                                                            <div className='flexc'>
                                                                <p className='font-size-12 main-c4 text-lined'>{checkTranslation(props.product?.priceSttings?.priceBeforeDiscount)} </p>
                                                                <p className='font-size-12 mld-3 red-box-fill px-2 br-30' style={{ color: '#fff' }}> {props.product?.priceSttings?.discount.value} {props.product?.priceSttings?.discount.type != 'cash' ? '%' : ''}</p>
                                                            </div>
                                                        </div>
                                                    </Responsive>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='flexc mt-3'>
                                                            <div className='br-20' style={{ width: "20px", height: "20px", border: "1px solid #ddd", backgroundColor: props.product?.colorb }}></div>
                                                            <p className='mld-3 font-size-14'>{checkTranslation(props.product?.color)} White</p>
                                                        </div>
                                                    </Responsive>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='d-flex mt-3'>
                                                            <img className='h-100 mrd-3' style={{ marginTop: "1px" }} width={18} src='/assets/icons/commerce/shield-gray.svg' />
                                                            <p className='font-size-12 des-color'>{checkTranslation(props.product?.warranty)} 2 Years of Warranty</p>
                                                        </div>
                                                    </Responsive>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='flexc mt-3'>
                                                            <img className='h-100 mrd-3' style={{ marginTop: "1px" }} width={18} src='/assets/icons/commerce/location-gray.svg' />
                                                            <p className='font-size-12 des-color'>{checkTranslation(props.product?.shop)} Apple Store</p>
                                                        </div>
                                                    </Responsive>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='flexc mt-3'>
                                                            <img className='h-100 mrd-3' style={{ marginTop: "1px" }} width={18} src='/assets/icons/commerce/instuck-gray.svg' />
                                                            <p className='font-size-12 des-color'>{checkTranslation(props.product?.availability)} Availble</p>
                                                        </div>
                                                    </Responsive>
                                                    <Responsive className={'d-flex'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "6", xl: "6" }}>
                                                        <div className='flexc mt-3'>
                                                            <img className='h-100 mrd-3' style={{ marginTop: "1px" }} width={18} src='/assets/icons/commerce/truck-gray.svg' />
                                                            <p className='font-size-12 des-color'>{checkTranslation(props.product?.shipping)} in 2 Days</p>
                                                        </div>
                                                    </Responsive>

                                                </div> */}
                                                    </div>

                                                </Responsive>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                    </Responsive>


                    <Responsive className='flex-1' width={this.props.width} media={{ xs: "12", sm: '12', md: '4', lg: "4", xl: "3" }}>
                        <div className={'mrd-5 p-3 br-10 position-sticky  ' + (this.props.width > 768 ? '' : ' mld-5 ')} style={{ backgroundColor: "#fff", top: 15 }}>
                            <CommerceInvoiceCalculations variables={this.props.variables} taxes={this.state.taxes} applet={this.props.applet} />

                            <div className='d-flex my-2'>

                                <p className='font-size-12 main-c6'>By Continuing this step you will accept the price of paying in the next step plus shipping time.</p>
                            </div>
                            <div className=' d-flex justify-content-center mt-3'>
                                <button className='br-8 px-5 py-2 w-100 ' style={{ background: background ?? '#007aff' }} onClick={() => this.props.changeStage("delivery")}>
                                    <p className='font-size-14 white py-1 text-semibold' >{translate('Continue')}</p>
                                </button>
                            </div>


                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartCheckout);